export function WatermarkSelect({ value, onChange }) {
  return (
    <label>
      Watermark
      <select id="watermark-select-value" name="value" value={value} onChange={(e) => onChange(e.target.value)} className="touch-target" style={{ display: "block", width: "100%" }}>
        <option value="None">None</option>
        <option value="Draft">Draft</option>
        <option value="Final">Final</option>
      </select>
    </label>
  );
}
